import React from 'react';
import * as keyset from 'i18n/AliceSkillForm';
import i18n from '@yandex-int/i18n';
import { DocumentationTypo } from './DocumentationTypo';
import { Note } from '../Note/Note';

const t = i18n(keyset);
const { Paragraph } = DocumentationTypo;

export const DevPreviewBanner: React.FC = () => {
    return (
        <Paragraph>
            <Note type="warning">{t('attention-func-in-dev')}</Note>
        </Paragraph>
    );
};
